var image_upload_default = {
  "container": "Tb-ob",
  "disabled": "_2-Vzm",
  "imageInput": "bUjly",
  "overlay": "g6lg3",
  "text": "_6HMTs",
  "shown": "WVpvA",
  "hide": "LtVNS",
  "spinner": "EZcOP",
  "spin": "NdlCY"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
